import axios from 'axios';
import $bridge from '@common/bridge';
import $store from '@store';
import qs from 'qs';
import detector from './detector';

export default () => {
    const http = axios.create();
    http.defaults.baseURL = '/api';
    http.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    http.defaults.headers['Access-Control-Allow-Origin'] = '*';
    http.defaults.transformRequest = http.defaults.transformRequest || [];
    http.defaults.transformRequest.push((data) => {
        if (typeof data === 'object') {
            return data;
        }

        let str = '';
        if (!data) {
            return str;
        }
        try {
            const json = JSON.parse(data);
            for (const a in json) {
                if (str !== '') {
                    str += `&${a}=${encodeURIComponent(json[a])}`;
                } else {
                    str += `${a}=${encodeURIComponent(json[a])}`;
                }
            }
            return str;
        } catch (error) {
            return data;
        }
    });
    http.interceptors.request.use((config = {}) => {
        const after = { ...config };
        var publicParams = { //公共参数
            deviceId: $store.state.system.deviceId || detector.deviceId,
            deviceName: detector.deviceName,
            deviceOs: detector.deviceOs,
            srcCode: 6,
            appVersion: detector.appVersion,
        };
        //if (config.headers['Content-Type'] ==='application/x-www-form-urlencoded' || config.headers['Content-Type'] ==="application/json") {
          if(config.method==='post'){ 
            publicParams={
                ...publicParams,
                ...config.data
            };
            after.data = qs.stringify(publicParams);
        }
        else { //config.method==='get'
            publicParams={
                ...publicParams,
                ...config.params
            };
            after.params = publicParams;
        }
        const havToken = $store.state.system.authorization;
        config.headers.Authorization = havToken.includes('Bearer')
            ? `${havToken}`
            : `Bearer ${havToken}`;
        if ($bridge.isApp && havToken) {
            config.headers.Authorization = havToken; // `Bearer ${havToken}`
        }
        return after;
    });
    http.interceptors.response.use(
        (rsp) => {
            const data = rsp.data;
            // if (rsp.status === 200 && data.returnCode === 0) {
            //     return data;
            // }
            if (rsp.status === 200) {
                return data;
            }
            // return data;
            return Promise.reject(data);
        },
        (error) => {
            console.error(error);
            const errData = {
                returnCode: error.response.status,
                returnMessage: '获取信息失败啦，请稍后再试~',
            };
            console.log(error, 'error');
            return Promise.reject(errData);
        }
    );
    return http;
};
